import React, { useState } from 'react';
import styled from 'styled-components';
import { ModalBase } from './ModalBase';
import { ModalUncontrolled } from './ModalUncontrolled';
const StyledDiv = styled.div `
  width: fit-content;
  display: inline-block;
`;
export const Modal = (props) => {
    const { open } = props;
    const [useUncontrolled] = useState(!('open' in props) || open === undefined);
    return useUncontrolled ? (React.createElement(StyledDiv, { "data-testid": "modal-uncontrolled" },
        React.createElement(ModalUncontrolled, Object.assign({}, props)))) : (React.createElement(StyledDiv, { "data-testid": "modal-controlled" },
        React.createElement(ModalBase, Object.assign({}, props))));
};
//# sourceMappingURL=Modal.js.map